@if (hasLabels) {
  <pm-labels-overlay class="pm-remove-when-dragging" [context]="context"></pm-labels-overlay>
}
@if (hasLinks) {
  <pm-link-overlay class="pm-remove-when-dragging" [node]="context"
  (linkClicked)="linkClicked($event)" [highlightInfo]="context?.highlights?.info"></pm-link-overlay>
}
<div class="bullet pm-user-content" [pmTrumbowyg]="trumbowygOptions" (pmLinkClick)="linkClicked($event)"
  [class.text-highlight]="context?.highlights?.text" [offsetElement]="nativeElement"
[innerHtml]="context.label | unsafeHtml" [enabled]="isEditingText"></div>

@if (isActive && context.autoTranslated.text) {
  <div class="mat-small pm-auto-translate-notice pm-remove-when-dragging">{{'menu.link.auto-translated' | translate}}</div>
}
<pm-menu-trigger-overlay (click)="toggleMenu($event)"></pm-menu-trigger-overlay>

@if (isActive) {
  <pm-options-overlay class="pm-remove-when-dragging" [context]="context" [contextElement]="elementRef"
  (toggleEdit)="toggleEdit($event)" (click)="prevent($event)"></pm-options-overlay>
}
@if (hasLinks) {
  <pm-link-menu class="pm-remove-when-dragging" [node]="context"
    [open]="isActive && !isEditingText" [isAuthor]="isAuthor"
  (linkClicked)="linkClicked($event)"></pm-link-menu>
}
